module.exports = __webpack_public_path__ + "static/img/RWDA665-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWDA665-G_1.png
// module id = dZSo
// module chunks = 0